import React from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyPage } from './EmptyPage';


const Forbidden: React.FC = () => {
  const { t: translate } = useTranslation();

  return (
    <EmptyPage
      imageName="accessDenied"
      title={translate('common:httpStatus.forbidden.title')}
      subtitle={translate('common:httpStatus.forbidden.subtitle')}
    />
  );
};

export default Forbidden;
